import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleSecuriteInformatiqueFondamentaux() {
  return (
    <BlogArticleLayout
      tag="Cybersécurité"
      title="Sécurité informatique en entreprise : les fondamentaux à connaître"
      date="27 octobre 2026"
      ctaTitle="Faites le point technique sur votre infrastructure"
      ctaText="Le diagnostic couvre ces fondamentaux techniques et les traduit en plan d'action priorisé pour votre DSI."
    >
      <p style={s.intro}>
        Ce guide s'adresse plus spécifiquement aux DSI et responsables informatiques qui souhaitent structurer
        leur approche de la sécurité au-delà des bonnes pratiques générales. Il reprend les principes
        fondamentaux sur lesquels s'appuient la plupart des référentiels de sécurité, dont ISO 27001.
      </p>

      <h2 style={s.h2}>La défense en profondeur</h2>
      <p>
        Aucune mesure unique n'est infaillible. Le principe de défense en profondeur consiste à superposer
        plusieurs couches de protection (réseau, poste de travail, application, données) de sorte que la
        défaillance d'une couche ne compromette pas l'ensemble du système.
      </p>

      <h2 style={s.h2}>La gestion des identités et des accès</h2>
      <p>
        Le principe du moindre privilège consiste à n'accorder à chaque utilisateur que les accès strictement
        nécessaires à sa fonction, ni plus ni moins. Cela implique une revue régulière des droits, en
        particulier lors des changements de poste ou des départs, et l'usage systématique de la double
        authentification sur les accès sensibles.
      </p>

      <h2 style={s.h2}>La segmentation réseau</h2>
      <p>
        Séparer les différents segments du réseau (postes utilisateurs, serveurs, systèmes de production)
        limite la propagation d'une compromission : une machine infectée sur un segment isolé ne donne pas
        automatiquement accès à l'ensemble du système d'information.
      </p>

      <h2 style={s.h2}>La gestion des correctifs (patch management)</h2>
      <p>
        Un processus formalisé de suivi et d'application des mises à jour de sécurité, avec des délais définis
        selon la criticité des vulnérabilités, réduit une part importante de la surface d'attaque exploitable.
      </p>

      <h2 style={s.h2}>La journalisation et la détection</h2>
      <p>
        Conserver et surveiller les journaux d'activité (connexions, accès aux fichiers sensibles, tentatives
        échouées) permet de détecter une activité anormale avant qu'elle ne dégénère en incident majeur, et
        facilite l'investigation en cas de problème avéré.
      </p>

      <h2 style={s.h2}>Le chiffrement et la règle de sauvegarde 3-2-1</h2>
      <p>
        Chiffrer les données sensibles au repos et en transit limite l'impact d'un vol ou d'une interception.
        La règle de sauvegarde 3-2-1 (trois copies des données, sur deux types de support différents, dont une
        copie hors site) reste une référence simple pour garantir une capacité de restauration fiable, y
        compris face au ransomware — voir notre
        {' '}<Link to="/blog/ransomware-entreprise-comprendre-se-proteger" style={s.link}>article dédié</Link>.
      </p>

      <h2 style={s.h2}>De ces fondamentaux à une démarche formalisée</h2>
      <p>
        Ces principes constituent la base sur laquelle s'appuie un système de management de la sécurité de
        l'information structuré — voir notre article
        {' '}<Link to="/blog/iso27001-pme-accessible" style={s.link}>ISO 27001 pour les PME</Link>{' '}
        pour comprendre comment les formaliser dans une démarche complète.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleSecuriteInformatiqueFondamentaux;
